<template>
  <div class="header">
    <div v-if="canBack" class="header-icon" @click="goBack()">
      <span class="iconfont icon-fanhui"></span>
    </div>
    <div class="header-title">{{ title }}</div>
    <div v-if="canBack" class="empty-class"></div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: () => '',
    },
    canBack: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    goBack() {
      window.history.back(-1);
    },
  },
};
</script>
<style scoped>
.header {
  position: sticky;
  top: 0;
  display: flex;
  width: 100%;
  height: 90px;
  align-items: center;
  font-size: 36px;
  font-weight: bold;
  background: #fff;
  color: #333;
  z-index: 99;
  box-shadow: 0 6px 6px #e9eaeb;
}

.header-title {
  flex: 1;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.header-icon {
  width: 52px;
  text-align: right;
}

.empty-class {
  width: 52px;
}
</style>